import React from 'react';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import CommonButton from '@src/new-components/Button';
import WrapperStepContent from '../WrapperStepContent';
import Sentences from './Sentences';

const VoiceRecord = ({ onSetStep }) => {
  const { t } = useTranslation();

  return (
    <WrapperStepContent onSetStep={onSetStep}>
      <Sentences />
      <CommonButton
        variant="contained"
        textProps={{
          variantText: 'body-14-bold',
          color: COLOR.darkBlue,
        }}
        customStyle={{
          width: 'max-content',
          margin: '0 auto',
        }}
      >
        {t('startRecordingV2')}
      </CommonButton>
    </WrapperStepContent>
  );
};

export default VoiceRecord;
